


import { createSlice } from "@reduxjs/toolkit";

const portalUsersSlice = createSlice({
    name: 'portalUsers',
    initialState: [],
    reducers: {
        addPortalUsers: (state, action): any => {
            const newState: any = [
                ...state,
            
            ]
            if(newState.indexOf(action.payload) === -1){
                newState.push(action.payload)
            }
            return newState
        },
        removePortalUsers: (state, action): any => {
            const newState: any = [
                ...state,
            
            ]
            const foundIndex = newState.indexOf(action.payload)
            if( foundIndex !== -1){
                newState.splice(foundIndex, 1)
            }
            return newState
        },
    },
});
export const { addPortalUsers, removePortalUsers } = portalUsersSlice.actions;
export default portalUsersSlice.reducer;